module.exports = __webpack_public_path__ + "assets/img/8a7d-kn.svg";